module.exports = __webpack_public_path__ + "logo_login.ce9af5d727f030062279.png";


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/img/logo_login.png
// module id = ../../../../../src/img/logo_login.png
// module chunks = styles